{
  "version": 1,
  "asset_id": "79f82865-28c5-4a7c-9331-3a9187233985",
  "project_id": "7580f3ab-e7a4-418d-abe6-5eb616986e51",
  "url": "/__l5e/assets-v1/79f82865-28c5-4a7c-9331-3a9187233985/beverly-hills-shingle-replacement-in-progress-768w.webp",
  "r2_key": "a/v1/7580f3ab-e7a4-418d-abe6-5eb616986e51/79f82865-28c5-4a7c-9331-3a9187233985/beverly-hills-shingle-replacement-in-progress-768w.webp",
  "original_filename": "beverly-hills-shingle-replacement-in-progress-768w.webp",
  "size": 56692,
  "content_type": "image/webp",
  "created_at": "2026-07-29T14:07:08Z"
}
